export default "__VITE_PUBLIC_ASSET__4d845602__"